import styled from 'styled-components';

// Breakpoints (max-width) — alinhados ao Bootstrap
const BP_XS  = 575;   // < 576px  — smartphones retrato
const BP_SM  = 767;   // < 768px  — smartphones paisagem
const BP_MD  = 991;   // < 992px  — tablets
const BP_LG  = 1199;  // < 1200px — laptops/notebooks
const BP_XL  = 1399;  // < 1400px — desktops
const BP_XXL = 1649;  // < 1650px — começa a adaptar aqui

const TEIA_PRIMARY = '#0066B3';

/* ─── Card wrapper ──────────────────────────────────────────── */
export const Card = styled.div<{ $interactive?: boolean; $isHidden?: boolean }>`
  background: ${({ $isHidden }) => ($isHidden === true ? '#e4ebf2' : '#fff')};
  border: ${({ $isHidden }) => ($isHidden === true ? '1px solid #c5d4e6' : '1px solid transparent')};
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 20px 24px 0;
  display: flex;
  align-items: stretch;
  position: relative;
  box-sizing: border-box;
  cursor: ${({ $interactive }) => ($interactive === true ? 'pointer' : 'default')};

  @media (max-width: ${BP_XXL}px) { padding: 18px 22px 0; }
  @media (max-width: ${BP_XL}px)  { padding: 16px 20px 0; }
  @media (max-width: ${BP_LG}px)  { padding: 16px 18px 0; }
  @media (max-width: ${BP_MD}px)  { padding: 14px 14px 0; }
  @media (max-width: ${BP_SM}px)  { padding: 12px 12px 0; }
  @media (max-width: ${BP_XS}px)  { padding: 10px 10px 10px; }
`;

/* ─── Logo ──────────────────────────────────────────────────── */
export const Logo = styled.img`
  width: 64px;
  height: 64px;
  object-fit: contain;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  margin-right: 12px;
  background: #fff;
  flex-shrink: 0;

  @media (max-width: ${BP_MD}px) { width: 52px; height: 52px; }
  @media (max-width: ${BP_SM}px) { width: 44px; height: 44px; }
  @media (max-width: ${BP_XS}px) { width: 36px; height: 36px; margin-right: 8px; }
`;

/* ─── Layout principal ──────────────────────────────────────── */
export const MainBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  min-width: 0;
`;

export const TopRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;
  margin-bottom: 12px;

  @media (max-width: ${BP_SM}px) { gap: 8px; margin-bottom: 8px; }
  @media (max-width: ${BP_XS}px) { gap: 6px; margin-bottom: 6px; }
`;

export const LogoColumn = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
  width: 64px;

  @media (max-width: ${BP_MD}px) { width: 52px; }
  @media (max-width: ${BP_SM}px) { width: 44px; }
  @media (max-width: ${BP_XS}px) { width: 36px; }
`;

export const TopInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
  min-width: 0;
`;

/* ─── Linha inferior (infos + botões) ───────────────────────── */
export const BottomRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;

  @media (max-width: ${BP_SM}px) { margin-top: 8px; margin-bottom: 8px; }
  @media (max-width: ${BP_XS}px) { margin-top: 6px; margin-bottom: 6px; gap: 6px; }
`;

/* TextCol: as 4 InfoCols ficam em linha e quebram conforme o espaço */
export const TextCol = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px 20px;
  flex: 1 1 0;
  min-width: 0;
  padding: 10px 16px 10px 0;
  box-sizing: border-box;

  @media (max-width: ${BP_LG}px) { gap: 10px 14px; padding: 8px 12px 8px 0; }
  @media (max-width: ${BP_MD}px) { gap: 8px 12px;  padding: 8px 8px 8px 0;  }
  @media (max-width: ${BP_SM}px) { gap: 8px 10px;  padding: 6px 6px 6px 0;  }
  @media (max-width: ${BP_XS}px) { gap: 6px 8px;   padding: 6px 0;           }
`;

/* InfoCol: cada bloco de info tem base mínima de 110px e cresce/encolhe */
export const InfoCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1 1 130px;
  min-width: 0;

  @media (max-width: ${BP_LG}px) { flex-basis: 120px; }
  @media (max-width: ${BP_MD}px) { flex-basis: 110px; }
  @media (max-width: ${BP_XS}px) { flex-basis: 100px; }
`;

/* ButtonCol: fica à direita em telas grandes, vai para baixo em telas pequenas */
export const ButtonCol = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-shrink: 0;
  padding-top: 10px;
  padding-bottom: 18px;

  @media (max-width: ${BP_MD}px) { padding-top: 8px; padding-bottom: 14px; }

  /* Em telas pequenas o botão ocupa a linha inteira */
  @media (max-width: ${BP_SM}px) {
    width: 100%;
    justify-content: flex-start;
    padding-top: 4px;
    padding-bottom: 12px;
  }
`;

/* ─── Tipografia ────────────────────────────────────────────── */
export const Titles = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
`;

export const Title = styled.div`
  color: #464646;
  font-weight: 700;
  font-size: 16px;
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;

  @media (max-width: ${BP_MD}px) { font-size: 15px; }
  @media (max-width: ${BP_XS}px) { font-size: 14px; }
`;

export const Activity = styled.div`
  color: #838383;
  font-size: 13px;
  font-weight: 400;
  margin-top: 2px;
  overflow-wrap: break-word;
  word-break: break-word;

  @media (max-width: ${BP_XS}px) { font-size: 12px; }
`;

export const Pitch = styled.div`
  color: #464646;
  font-size: 13px;
  font-weight: 400;
  margin-top: 4px;
  max-width: 100%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${BP_XS}px) { font-size: 12px; }
`;

export const InfoTitle = styled.div`
  color: #464646;
  font-weight: 600;
  font-size: 13px;

  @media (max-width: ${BP_XS}px) { font-size: 12px; }
`;

export const InfoValue = styled.div`
  color: #464646;
  font-size: 13px;
  font-weight: 400;

  @media (max-width: ${BP_XS}px) { font-size: 12px; }
`;

export const EcosystemBadge = styled.span`
  padding: 4px 10px;
  background-color: #c5e6ff;
  color: #464646;
  font-weight: 500;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
`;

export const Divider = styled.hr`
  border: 0.5px solid #c4c5c6;
  margin: 0;
  width: 100%;
`;

/* ─── Botões ────────────────────────────────────────────────── */
export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: ${BP_SM}px) { width: 100%; }
`;

export const ViewProfileButton = styled.button`
  width: 99px;
  height: 32px;
  padding: 0 16px;
  gap: 8px;
  border-radius: 4px;
  border: none;
  background: ${TEIA_PRIMARY};
  color: #fff;
  font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${BP_SM}px) { flex: 1; width: auto; }

  &:hover { opacity: 0.9; }
`;

export const SelectButton = styled.button`
  width: 106px;
  height: 32px;
  padding: 0 16px;
  gap: 8px;
  border-radius: 4px;
  border: none;
  background: ${TEIA_PRIMARY};
  color: #fff;
  font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${BP_SM}px) { flex: 1; width: auto; }

  &:hover { opacity: 0.9; }
`;

export const ActionsButton = styled.button`
  width: 32px;
  height: 32px;
  background: #fff;
  border: 1px solid ${TEIA_PRIMARY};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${TEIA_PRIMARY};
  flex-shrink: 0;

  &:hover { background: #f0f7ff; }
`;

export const ActionsWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: ${BP_SM}px) { width: 100%; }
`;

export const ActionsDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  z-index: 1000;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  overflow: hidden;
`;

export const ActionsDropdownButton = styled.button`
  width: 220px;
  min-height: 40px;
  padding: 10px 16px;
  background: #fff;
  border: none;
  color: #464646;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  pointer-events: auto;

  &:hover { background: #f5f5f5; }
`;
